import { connect } from 'react-redux'

import { getBoxPositions } from 'selectors/feature/functionGraphs'
import {
  getNodeCarrySimulationEvaluation,
  getSimulationMeta,
} from 'selectors/feature/simulation'
import { getIsSimulating } from 'selectors/navigator'

import NodeConnector from './NodeConnector'

const mapStateToProps = (state, ownProps) => {
  const { carryNodeUri, rungNodeUri, fnId } = ownProps

  const findBoxPositions = getBoxPositions()

  const { childBoxPosition: carryBoxPosition } = findBoxPositions(state, {
    parentQueryUri: rungNodeUri,
    subQueryUri: carryNodeUri,
    id: fnId,
  })

  const isSimulating = getIsSimulating(state)
  const nodeCarryEvaluation = getNodeCarrySimulationEvaluation(state, {
    queryUri: carryNodeUri,
  })

  const { playing } = getSimulationMeta(state)

  return {
    carryBoxPosition,
    isSimulating,
    nodeCarryEvaluation,
    simulationPlaying: playing,
  }
}

const NodeConnectorContainer = connect(mapStateToProps)(NodeConnector)

export default NodeConnectorContainer
